module.exports = __webpack_public_path__ + "img/teamSystem.e4316436.png";